/**
 * Everything amplitude tracking!
 */

import React from 'react';
import { useTracking } from '@podiumhq/tracking';

/**
 * Used to wrap your sub-app. Enabling you to track Amplitude events.
 * @param {Object} props Props for the AmplitudeProvider component.
 */
function AmplitudeProvider({ children }) {
  const { Track } = useTracking();

  return <Track>{children}</Track>;
}

export default AmplitudeProvider;
